import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { dispatch } from '../../dispatcher/Dispatcher';

import { getItem as getLang } from '../../common/lang';

import Header from '../../components/Header/Header.jsx';
import PullLoader from '../../components/PullLoader/PullLoader.jsx';
import RecordList from '../../components/RecordList/RecordList.jsx';
import FormControl from '../../components/FormControl/FormControl.jsx';
import TextInput from '../../components/TextInput/TextInput.jsx';
import Button from '../../components/Button/Button.jsx';
import Form from '../../components/Form/Form.jsx';
import Loader from '../../components/Loader/Loader.jsx';
import PageOpener from '../../components/PageOpener/PageOpener.jsx';

import RepairClockInStore from '../../stores/RepairClockInStore';
import RepairClockInDataUtils from '../../data-utils/RepairClockInDataUtils';

class RepairClockInCheckList extends Component {
    static getStores() {
		return [RepairClockInStore];
	}

	static calculateState() {
		return RepairClockInStore.getState();
	}
	constructor(props){
		super(props);
		RepairClockInDataUtils.getEmpRciPeriodList();
	}

    render(){
		const{
			selectTable,
			periodList = [],
			submitting = false,
			status = 'loading',
			pid = 0  //审核通过回调的PID
		} = this.state;

		//核算成功后跳转到对应列表
		if(pid > 0){
			window.location.href='#/my-rci/viewlist/'+pid;
		}
        return (<div>
				<Header
					back
					title={getLang('RCI_CHECK_DATA')}
				/>
				<PullLoader ref="pullLoader" status={status} ></PullLoader>
				<ul className={'record-list' + (selectTable ? ' record-list-selectable' : '')}>
					{
						periodList.map((item, index) => {
							return(
								<li>
									<a href="javascript:;" className='record-item' onClick={this.check.bind(this, item.pla_per_id)}>
										<span className='record-item-name'>{item.pla_per_code}</span>
										{/*<span className='record-item-time'>123</span>*/}
										<span className='record-item-hours record-choose' >核算</span>
										{/*<span className={'record-item-status record-item-status-'}>123</span>*/}
									</a>
								</li>
							);
						})
					}
				</ul>
				</div>);
    }

	check(pid, e){
		if(confirm(getLang('RCI_AUS_CHECK'))){
			RepairClockInDataUtils.checkRciExList(pid);
		}
	}
}

export default Container.create(RepairClockInCheckList);


// WEBPACK FOOTER //
// ./src/containers/RepairClockIn/RepairClockInEmpCheckListContainer.js